angular.module('ihestiaRestServicesBase')
   .factory('claimIssueSvc', [ 'IHestiaRestServiceAbstractDef',
    function(IHestiaRestServiceAbstractDef) {

    var ClaimIssue = function()
    {
      IHestiaRestServiceAbstractDef.apply(this, arguments);

      this.basePattern = '{host}{port}{path}/{businessArea}/{apiString}/{resource}{id}{subResource}';
      this.businessArea = 'iszkody';
      this.resource = 'secured/issue';
    };

    return new ClaimIssue();
  }])
;